import dashboardHtml from './dashboard.html';
import * as moment from 'moment';

class DashboardController {
    constructor($scope, $timeout, $http, translateService, $locale) {
        'ngInject';

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$http = $http;
        this.translate = translateService;
        this.$locale = $locale;
        $locale.NUMBER_FORMATS.GROUP_SEP = ' ';

        this.shops = [];

        const currentDate = new Date();
        const dateMathYear= new Date();
        const dateFromYear = new Date(dateMathYear.setDate(dateMathYear.getDate() - (30 * 12)));

        const dateMathMonth = new Date();
        const dateFromMonth = new Date(dateMathMonth.setDate(dateMathMonth.getDate() - (30 * 1)));

        this.completed = {
            loading: true,
            dateFrom: dateFromYear,
            dateTo: currentDate,
            shops: {},
            period: 'month',
            total: {},
            chart: null,
            summaryChart: null,
            selectedShops: {
                1: true,
                2: true,
                3: true,
                4: true,
                5: true,
            }
        };

        this.inProgress = {
            loading: true,
            dateFrom: dateFromMonth,
            dateTo: currentDate,
            shops: {},
            period: 'day',
            total: {},
            chart: null,
            summaryChart: null,
            selectedShops: {
                1: true,
                2: true,
                3: true,
                4: true,
                5: true,
            }
        };

        this.complaints = {
            loading: true,
            dateFrom: dateFromYear,
            dateTo: currentDate,
            shops: {},
            period: 'month',
            total: {},
            chart: null,
            summaryChart: null,
            selectedShops: {
                1: true,
                2: true,
                3: true,
                4: true,
                5: true,
            }
        };

        this.transport = {
            loading: true,
            dateFrom: dateFromYear,
            dateTo: currentDate,
            shops: {},
            period: 'month',
            total: {},
            chart: null,
            summaryChart: null,
            selectedShops: {
                1: true,
                2: true,
                3: true,
                4: true,
                5: true,
            }
        };

        this.productionTimes = {
            loading: true,
            dateFrom: dateFromMonth,
            dateTo: currentDate,
            data: {},
            period: 'month',
            total: {},
            chart: null,
            summaryChart: null,

        };



        this.shopColors = {
            1 : 'rgba(54, 162, 235, 0.2)',
            2 : 'rgba(255, 99, 132, 0.2)',
            3 : 'rgba(153, 102, 255, 0.2',
            4 : 'rgba(75, 192, 192, 0.2)',
            5 : 'rgba(255, 159, 64, 0.2)',
            6 : 'rgba(201, 203, 207, 0.2)'
        }

        this.shopBorderColors = {
            1 : 'rgba(54, 162, 235)',
            2 : 'rgba(255, 99, 132)',
            3 : 'rgba(153, 102, 255)',
            4 : 'rgba(75, 192, 192)',
            5 : 'rgba(255, 159, 64)',
            6 : 'rgba(201, 203, 207)'
        }

        this.chartsConfig = {
            stacked : false,
        }
    }

    $onInit() {
        this.loadShops();
    }

    loadShops() {
        this.$http.get(
            `/admpanel/ajax/settings/getShops`
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.shops = response.data;
                }

                this.getData();
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    getData() {
            this.getCompletedData();
            this.getInProgressData();
            this.getTransportData();
            this.getComplaintsData();
            this.getProductionTimesData();
    }


    getCompletedData() {
        this.completed.loading = true;
        this.$http.post(
            `/admpanel/ajax/settings/dashboard/getCompletedOrders`,
            {
                dateFrom: this.formatDatepickerDate(this.completed.dateFrom),
                dateTo: this.formatDatepickerDate(this.completed.dateTo),
                period: this.completed.period,
            }
        ).then(
            (response) => {
                this.completed.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.completed.shops = response.data;
                    this.completed.total = this.sumValuesForShop(response.data);
                }

                this.handleCompletedChart();
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    getInProgressData() {
        this.inProgress.loading = true;
        this.$http.post(
            `/admpanel/ajax/settings/dashboard/getInProgressOrders`,
            {
                dateFrom: this.formatDatepickerDate(this.inProgress.dateFrom),
                dateTo: this.formatDatepickerDate(this.inProgress.dateTo),
                period: this.inProgress.period,
            }
        ).then(
            (response) => {
                this.inProgress.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.inProgress.shops = response.data;
                    this.inProgress.total = this.sumValuesForShop(response.data);
                }

                this.handleInProgressChart();
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    getTransportData() {
        this.transport.loading = true;
        this.$http.post(
            `/admpanel/ajax/settings/dashboard/getShipmentsCost`,
            {
                dateFrom: this.formatDatepickerDate(this.transport.dateFrom),
                dateTo: this.formatDatepickerDate(this.transport.dateTo),
                period: this.transport.period,
            }
        ).then(
            (response) => {
                this.transport.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.transport.shops = response.data;
                    this.transport.total = this.sumValuesForShop(response.data);
                }

                console.log('ttotal',   this.transport.total);
                this.handleTransportChart();
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    getComplaintsData() {
        this.complaints.loading = true;
        this.$http.post(
            `/admpanel/ajax/settings/dashboard/getComplaints`,
            {
                dateFrom: this.formatDatepickerDate(this.complaints.dateFrom),
                dateTo: this.formatDatepickerDate(this.complaints.dateTo),
                period: this.complaints.period,
            }
        ).then(
            (response) => {
                this.complaints.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.complaints.shops = response.data;
                    this.complaints.total = this.sumValuesForShop(response.data);
                    this.handleComplaintsChart();
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    getProductionTimesData() {
        this.productionTimes.loading = true;
        this.$http.post(
            `/admpanel/ajax/settings/dashboard/getProductionTimes`,
            {
                dateFrom: this.formatDatepickerDate(this.productionTimes.dateFrom),
                dateTo: this.formatDatepickerDate(this.productionTimes.dateTo),
            }
        ).then(
            (response) => {
                this.productionTimes.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.productionTimes.data = response.data;
                    this.productionTimes.data.summary = {
                        'chain' : Math.round(response.data.reduce((accumulator, object) => {
                            return accumulator + object.chain;
                        }, 0)),
                        'laser' : Math.round(response.data.reduce((accumulator, object) => {
                            return accumulator + object.laser;
                        }, 0)),
                        'chainPolished' : Math.round(response.data.reduce((accumulator, object) => {
                            return accumulator + object.chainPolished;
                        }, 0)),
                        'frez' : Math.round(response.data.reduce((accumulator, object) => {
                            return accumulator + object.frez;
                        }, 0))
                    }

                    this.handleProductionTimesCharts();
                }

                console.log(this.productionTimes.data.summary);
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    formatDatepickerDate(date) {
        return moment(date, true).format('YYYY-MM-DD')
    }

    handleCompletedChart() {
        Chart.register(pluginTrendlineLinear);
         //Doughnut chart
         let summaryDatasetsTmp = {
            'number_of_orders': [],
            'value_of_invoiced_orders_in_pln' : [],
            'colors': [],
            'colorsBg': []
         };

        const doughCanvasEleSummary = document.getElementById('orders_summary_charts');

        for (const shop of this.getShopsForStats('completed')) {
            summaryDatasetsTmp['number_of_orders'].push(parseFloat(this.completed.total[shop.id].number_of_orders)) ;
            summaryDatasetsTmp['colors'].push(this.shopBorderColors[shop.id]) ;
            summaryDatasetsTmp['value_of_invoiced_orders_in_pln'].push(parseFloat(this.completed.total[shop.id].value_of_invoiced_orders_in_pln)) ;
        }

        let summaryDatasets = [
            {
                label: 'Ilość zamówien',
                data: summaryDatasetsTmp['number_of_orders'],
                backgroundColor: summaryDatasetsTmp['colors'],
            },
            {
                label: 'Wartość dla Contry w PLN',
                data: summaryDatasetsTmp['value_of_invoiced_orders_in_pln'],
                backgroundColor: summaryDatasetsTmp['colors'],
            }
        ];

        if (this.completed.summaryChart) {
            this.completed.summaryChart.destroy();
        }

        this.completed.summaryChart  = new Chart(doughCanvasEleSummary.getContext('2d'), {
            type: 'doughnut',
            data: {
                labels: this.getShopsForStats('completed').map(shop => shop.name.substr(shop.name.indexOf('.'))),
                datasets: summaryDatasets,
            },
            options: {
                responsive: true,
            }
         });


        // Bar chart

        const tooltip = (tooltipItems) => {
            let sumOrders = 0;
            let sumValue = 0;
            tooltipItems.forEach(function(tooltipItem) {
                if (tooltipItem.dataset.stack == 'orders') {
                    sumOrders += tooltipItem.parsed.y;
                }

                if (tooltipItem.dataset.stack == 'value') {
                    sumValue += tooltipItem.parsed.y;
                }

            });

            return 'Suma zamówień: ' + sumOrders.toFixed(0) + '/ Łączna wartość: ' + sumValue.toFixed(2);
        };

        let labels = this.completed.shops[1].map(item => item.date);
        let dataSets = [];

        for (const shop of  this.getShopsForStats('completed')) {

            let dataSet = {
                label: 'Zam ' + shop.name.substr(shop.name.indexOf('.')),
                data: this.completed.shops[shop.id].map(item => item.number_of_orders),
                backgroundColor: this.shopColors[shop.id],
                borderColor:  this.shopBorderColors[shop.id],
                borderWidth: 1,
                stack: 'orders',
                yAxisID: 'y',
                // trendlineLinear: {
                //     colorMin: "red",
                //     colorMax: "green",
                //     lineStyle: "dotted",
                //     width: 2,

                // }
            }

            dataSets.push(dataSet);

            dataSet = {
                label: 'Wartość ' + shop.name.substr(shop.name.indexOf('.')),
                data: this.completed.shops[shop.id].map(item => item.value_of_invoiced_orders_in_pln),
                backgroundColor: this.shopBorderColors[shop.id],
                borderColor:  this.shopBorderColors[shop.id],
                borderWidth: 1,
                stack: 'value',
                yAxisID: 'y1',
                type: 'line',
                trendlineLinear: {
                    colorMin: this.shopBorderColors[shop.id],
                    colorMax: this.shopBorderColors[shop.id],
                    lineStyle: "solid",
                    width: 2,

                }
            }

            dataSets.push(dataSet);
        }

        // update
            // ('update', this.completed.chart.data.datasets);

            // this.completed.chart.data.labels.splice(0, this.completed.chart.data.labels.length);
            // this.completed.chart.data.datasets.forEach((dataset) => {
            //     dataset.data.splice(0, dataset.data.length);
            // });

            // labels.forEach( (label) => {
            //     this.completed.chart.data.labels.push(label);
            // });

            // this.completed.chart.data.datasets.forEach((dataset, index) => {

            //     dataSets[index].data.forEach((data) => {
            //         dataset.data.push(data);
            //     })

            // });

            // this.completed.chart.update();
        // end update
        if (this.completed.chart) {
            this.completed.chart.destroy();
        }

        const barCanvasEle = document.getElementById('orders_charts')

        this.completed.chart  = new Chart(barCanvasEle.getContext('2d'), {
            type: 'bar',
            data: {
                labels: labels,
                datasets: dataSets,
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {

                    x: {
                        stacked: true,
                        // time: {
                        //     unit: 'day'
                        // },
                        // type: 'time'
                    },
                    y: {
                        stacked: true
                    },
                    y1: {
                        type: 'linear',
                        display: true,
                        position: 'right',
                        // grid line settings
                        grid: {
                          drawOnChartArea: false, // only want the grid lines for one axis to show up
                        },
                      },
                },
                plugins: {
                    tooltip: {
                        callbacks: {
                            footer: tooltip,
                        }
                    }
                },
                interaction: {
                    mode: 'index',
                    intersect: false,
                },
            }
        });

    }

    handleInProgressChart() {
        Chart.register(pluginTrendlineLinear);
        //Doughnut chart
        let summaryDatasetsTmp = {
           'number_of_orders': [],
           'value_of_invoiced_orders_in_pln' : [],
           'colors': [],
           'colorsBg': []
        };

       const doughCanvasEleSummary = document.getElementById('orders_summary_charts_in_progress');

       for (const shop of this.getShopsForStats('inProgress')) {
           summaryDatasetsTmp['number_of_orders'].push(parseFloat(this.inProgress.total[shop.id].number_of_orders)) ;
           summaryDatasetsTmp['colors'].push(this.shopBorderColors[shop.id]) ;
           summaryDatasetsTmp['value_of_invoiced_orders_in_pln'].push(parseFloat(this.inProgress.total[shop.id].value_of_invoiced_orders_in_pln)) ;
       }

       let summaryDatasets = [
           {
               label: 'Ilość zamówien',
               data: summaryDatasetsTmp['number_of_orders'],
               backgroundColor: summaryDatasetsTmp['colors'],
           },
           {
               label: 'Wartość dla Contry w PLN',
               data: summaryDatasetsTmp['value_of_invoiced_orders_in_pln'],
               backgroundColor: summaryDatasetsTmp['colors'],
           }
       ];

       if (this.inProgress.summaryChart) {
           this.inProgress.summaryChart.destroy();
       }

       this.inProgress.summaryChart  = new Chart(doughCanvasEleSummary.getContext('2d'), {
           type: 'doughnut',
           data: {
               labels: this.getShopsForStats('inProgress').map(shop => shop.name.substr(shop.name.indexOf('.'))),
               datasets: summaryDatasets,
           },
           options: {
               responsive: true,
           }
        });


       // Bar chart

       const tooltip = (tooltipItems) => {
           let sumOrders = 0;
           let sumValue = 0;
           tooltipItems.forEach(function(tooltipItem) {
               if (tooltipItem.dataset.stack == 'orders') {
                   sumOrders += tooltipItem.parsed.y;
               }

               if (tooltipItem.dataset.stack == 'value') {
                   sumValue += tooltipItem.parsed.y;
               }

           });

           return 'Suma zamówień: ' + sumOrders.toFixed(0) + '/ Łączna wartość: ' + sumValue.toFixed(2);
       };

       let labels = this.inProgress.shops[1].map(item => item.date);
       let dataSets = [];

       for (const shop of  this.getShopsForStats('inProgress')) {

           let dataSet = {
               label: 'Zam ' + shop.name.substr(shop.name.indexOf('.')),
               data: this.inProgress.shops[shop.id].map(item => item.number_of_orders),
               backgroundColor: this.shopColors[shop.id],
               borderColor:  this.shopBorderColors[shop.id],
               borderWidth: 1,
               stack: 'orders',
               yAxisID: 'y',
           }

           dataSets.push(dataSet);

           dataSet = {
               label: 'Wartość ' + shop.name.substr(shop.name.indexOf('.')),
               data: this.inProgress.shops[shop.id].map(item => item.value_of_invoiced_orders_in_pln),
               backgroundColor: this.shopBorderColors[shop.id],
               borderColor:  this.shopBorderColors[shop.id],
               borderWidth: 1,
               stack: 'value',
               yAxisID: 'y1',
               type: 'line',
           }

           dataSets.push(dataSet);
       }

       if (this.inProgress.chart) {
           this.inProgress.chart.destroy();
       }

       const barCanvasEle = document.getElementById('orders_charts_in_progress')

       this.inProgress.chart  = new Chart(barCanvasEle.getContext('2d'), {
           type: 'bar',
           data: {
               labels: labels,
               datasets: dataSets,
           },
           options: {
               responsive: true,
               maintainAspectRatio: false,
               scales: {

                   x: {
                       stacked: true,
                   },
                   y: {
                       stacked: true
                   },
                   y1: {
                       type: 'linear',
                       display: true,
                       position: 'right',

                       grid: {
                         drawOnChartArea: false, // only want the grid lines for one axis to show up
                       },
                     },
               },
               plugins: {
                   tooltip: {
                       callbacks: {
                           footer: tooltip,
                       }
                   }
               },
               interaction: {
                   mode: 'index',
                   intersect: false,
               },
           }
       });

    }

    handleTransportChart() {
        Chart.register(pluginTrendlineLinear);
        //Doughnut chart
        let summaryDatasetsTmp = {
           'number_of_orders': [],
           'shipments_cost_net' : [],
           'colors': [],
           'colorsBg': []
        };

       const doughCanvasEleSummary = document.getElementById('orders_summary_charts_transport');

       for (const shop of this.getShopsForStats('transport')) {
           summaryDatasetsTmp['number_of_orders'].push(parseFloat(this.transport.total[shop.id].number_of_orders)) ;
           summaryDatasetsTmp['colors'].push(this.shopBorderColors[shop.id]) ;
           summaryDatasetsTmp['shipments_cost_net'].push(parseFloat(this.transport.total[shop.id].shipments_cost_net)) ;
       }

       let summaryDatasets = [
           {
               label: 'Ilość zamówien',
               data: summaryDatasetsTmp['number_of_orders'],
               backgroundColor: summaryDatasetsTmp['colors'],
           },
           {
               label: 'Wartość PLN',
               data: summaryDatasetsTmp['shipments_cost_net'],
               backgroundColor: summaryDatasetsTmp['colors'],
           }
       ];

       if (this.transport.summaryChart) {
           this.transport.summaryChart.destroy();
       }

       this.transport.summaryChart  = new Chart(doughCanvasEleSummary.getContext('2d'), {
           type: 'doughnut',
           data: {
               labels: this.getShopsForStats('transport').map(shop => shop.name.substr(shop.name.indexOf('.'))),
               datasets: summaryDatasets,
           },
           options: {
               responsive: true,
           }
        });


       // Bar chart

       const tooltip = (tooltipItems) => {
           let sumOrders = 0;
           let sumValue = 0;
           tooltipItems.forEach(function(tooltipItem) {
               if (tooltipItem.dataset.stack == 'orders') {
                   sumOrders += tooltipItem.parsed.y;
               }

               if (tooltipItem.dataset.stack == 'value') {
                   sumValue += tooltipItem.parsed.y;
               }

           });

           return 'Suma zamówień: ' + sumOrders.toFixed(0) + '/ Łączna wartość: ' + sumValue.toFixed(2);
       };

       let labels = this.transport.shops[1].map(item => item.date);
       let dataSets = [];

       for (const shop of  this.getShopsForStats('transport')) {

           let dataSet = {
               label: 'Zam ' + shop.name.substr(shop.name.indexOf('.')),
               data: this.transport.shops[shop.id].map(item => item.number_of_orders),
               backgroundColor: this.shopColors[shop.id],
               borderColor:  this.shopBorderColors[shop.id],
               borderWidth: 1,
               stack: 'orders',
               yAxisID: 'y',
           }

           dataSets.push(dataSet);

           dataSet = {
               label: 'Wartość ' + shop.name.substr(shop.name.indexOf('.')),
               data: this.transport.shops[shop.id].map(item => item.shipments_cost_net),
               backgroundColor: this.shopBorderColors[shop.id],
               borderColor:  this.shopBorderColors[shop.id],
               borderWidth: 1,
               stack: 'value',
               yAxisID: 'y1',
               type: 'line',
               trendlineLinear: {
                    colorMin: this.shopBorderColors[shop.id],
                    colorMax: this.shopBorderColors[shop.id],
                    lineStyle: "solid",
                    width: 2,

                }
           }

           dataSets.push(dataSet);
       }

       if (this.transport.chart) {
           this.transport.chart.destroy();
       }

       const barCanvasEle = document.getElementById('orders_charts_transport')

       this.transport.chart  = new Chart(barCanvasEle.getContext('2d'), {
           type: 'bar',
           data: {
               labels: labels,
               datasets: dataSets,
           },
           options: {
               responsive: true,
               maintainAspectRatio: false,
               scales: {

                   x: {
                       stacked: true,
                   },
                   y: {
                       stacked: true
                   },
                   y1: {
                       type: 'linear',
                       display: true,
                       position: 'right',

                       grid: {
                            drawOnChartArea: false, // only want the grid lines for one axis to show up
                       },
                     },
               },
               plugins: {
                   tooltip: {
                       callbacks: {
                           footer: tooltip,
                       }
                   }
               },
               interaction: {
                   mode: 'index',
                   intersect: false,
               },
           }
       });

    }

    handleComplaintsChart() {
        Chart.register(pluginTrendlineLinear);
        //Doughnut chart
        let summaryDatasetsTmp = {
           'number_of_orders': [],
           'value_of_invoiced_orders_in_pln' : [],
           'colors': [],
           'colorsBg': [],
           'total_costs': []
        };

       const doughCanvasEleSummary = document.getElementById('orders_summary_charts_complaints');

       for (const shop of this.getShopsForStats('complaints')) {
           summaryDatasetsTmp['number_of_orders'].push(parseFloat(this.complaints.total[shop.id].number_of_orders)) ;
           summaryDatasetsTmp['colors'].push(this.shopBorderColors[shop.id]) ;
           let totalCosts = parseFloat(this.complaints.total[shop.id].material_cost_net) + parseFloat(this.complaints.total[shop.id].cut_cost_net) + parseFloat(this.complaints.total[shop.id].shipment_cost_net)
           summaryDatasetsTmp['total_costs'].push(totalCosts) ;
       }

       let summaryDatasets = [
           {
               label: 'Ilość reklamacji',
               data: summaryDatasetsTmp['number_of_orders'],
               backgroundColor: summaryDatasetsTmp['colors'],
           },
           {
               label: 'Łączny koszt',
               data: summaryDatasetsTmp['total_costs'],
               backgroundColor: summaryDatasetsTmp['colors'],
           }
       ];

       if (this.complaints.summaryChart) {
           this.complaints.summaryChart.destroy();
       }

       this.complaints.summaryChart  = new Chart(doughCanvasEleSummary.getContext('2d'), {
           type: 'doughnut',
           data: {
               labels: this.getShopsForStats('complaints').map(shop => shop.name.substr(shop.name.indexOf('.'))),
               datasets: summaryDatasets,
           },
           options: {
               responsive: true,
           }
        });


       // Bar chart

       const tooltip = (tooltipItems) => {
           let sumOrders = 0;
           let sumValue = 0;
           tooltipItems.forEach(function(tooltipItem) {
               if (tooltipItem.dataset.stack == 'orders') {
                   sumOrders += tooltipItem.parsed.y;
               }

               if (tooltipItem.dataset.stack == 'value') {
                   sumValue += tooltipItem.parsed.y;
               }

           });

           return 'Łącznie reklamacji: ' + sumOrders.toFixed(0) + '/ Łączny koszt: ' + sumValue.toFixed(2);
       };

       let labels = this.complaints.shops[1].map(item => item.date);
       let dataSets = [];

       for (const shop of  this.getShopsForStats('complaints')) {

           let dataSet = {
               label: 'Reklamacji ' + shop.name.substr(shop.name.indexOf('.')),
               data: this.complaints.shops[shop.id].map(item => item.number_of_orders),
               backgroundColor: this.shopColors[shop.id],
               borderColor:  this.shopBorderColors[shop.id],
               borderWidth: 1,
               stack: 'orders',
               yAxisID: 'y',
           }

           dataSets.push(dataSet);

           dataSet = {
               label: 'Koszt ' + shop.name.substr(shop.name.indexOf('.')),
               data: this.complaints.shops[shop.id].map(item => parseFloat(item.material_cost_net) + parseFloat(item.cut_cost_net) + parseFloat(item.shipment_cost_net)),
               backgroundColor: this.shopBorderColors[shop.id],
               borderColor:  this.shopBorderColors[shop.id],
               borderWidth: 1,
               stack: 'value',
               yAxisID: 'y1',
               type: 'line',
           }

           dataSets.push(dataSet);
       }

       if (this.complaints.chart) {
           this.complaints.chart.destroy();
       }

       const barCanvasEle = document.getElementById('orders_charts_complaints')

       this.complaints.chart  = new Chart(barCanvasEle.getContext('2d'), {
           type: 'bar',
           data: {
               labels: labels,
               datasets: dataSets,
           },
           options: {
               responsive: true,
               maintainAspectRatio: false,
               scales: {

                   x: {
                       stacked: true,
                   },
                   y: {
                       stacked: true
                   },
                   y1: {
                       type: 'linear',
                       display: true,
                       position: 'right',

                       grid: {
                         drawOnChartArea: false, // only want the grid lines for one axis to show up
                       },
                     },
               },
               plugins: {
                   tooltip: {
                       callbacks: {
                           footer: tooltip,
                       }
                   }
               },
               interaction: {
                   mode: 'index',
                   intersect: false,
               },
           }
       });

    }

    handleProductionTimesCharts() {
        Chart.register(pluginTrendlineLinear);

       // Bar chart

       const tooltip = (tooltipItems) => {
           let sumTime = 0;

           tooltipItems.forEach(function(tooltipItem) {
               if (tooltipItem.dataset.stack == 'time') {
                    sumTime += tooltipItem.parsed.y;
               }
           });

           return 'Łącznie czas: ' + this.showNiceTime(sumTime) ;
       };

       let labels = this.productionTimes.data.map(item => item.date);
       let dataSets = [];


       dataSets = [
            {
                label: 'Laser',
                data: this.productionTimes.data.map(item => item.laser),
                backgroundColor: '#e4e534',
                borderColor:  '#e4e534',
                borderWidth: 1,
                stack: 'time',
                yAxisID: 'y',
            },
            {
                label: 'Piła',
                data: this.productionTimes.data.map(item => item.chain),
                backgroundColor: '#5d5d5d',
                borderColor:  '#5d5d5d',
                borderWidth: 1,
                stack: 'time',
                yAxisID: 'y',
            },
            {
                label: 'Polerowanie',
                data: this.productionTimes.data.map(item => item.chainPolished),
                backgroundColor: '#4b4cec',
                borderColor:  '#4b4cec',
                borderWidth: 1,
                stack: 'time',
                yAxisID: 'y',
            },
            {
                label: 'Frez',
                data: this.productionTimes.data.map(item => item.frez),
                backgroundColor: '#f40101',
                borderColor:  '#f40101',
                borderWidth: 1,
                stack: 'time',
                yAxisID: 'y',
            }
       ];



       if (this.productionTimes.chart) {
           this.productionTimes.chart.destroy();
       }

       const barCanvasEle = document.getElementById('orders_charts_productionTimes')

       this.productionTimes.chart  = new Chart(barCanvasEle.getContext('2d'), {
           type: 'bar',
           data: {
               labels: labels,
               datasets: dataSets,
           },
           options: {
               responsive: true,
               maintainAspectRatio: false,
               scales: {

                   x: {
                       stacked: true,
                   },
                   y: {
                        ticks: {
                            stepSize: (60 * 60),
                            beginAtZero: false,
                            callback: value => {
                                return this.showNiceTimeAxis(value);
                            }
                        },
                        stacked: true
                   },
               },
               plugins: {
                   tooltip: {
                       callbacks: {
                           footer: tooltip,
                       }
                   }
               },
               interaction: {
                   mode: 'index',
                   intersect: false,
               },
           }
       });

    }

    sumValuesForShop(data) {
        let returnData = {
            'summary' : {},
        };

        let sumParams = [
            {
                "name" : 'complaints_cost',
                'values': [
                    'material_cost_net',
                    'cut_cost_net',
                    'shipment_cost_net'
                ]
            }
        ];

        for (const shop of  this.shops) {
            let firstElement = data[shop.id][0];
            returnData[shop.id] = {};
            for (const param in firstElement) {

                if (firstElement.hasOwnProperty.call(firstElement, param)) {

                      let paramSum = data[shop.id].reduce((accumulator, object) => {
                        let valueData = parseFloat(object[param]);

                        if (isNaN(valueData)) {
                            valueData = 0;
                        }
                        return accumulator + valueData;
                    }, 0);


                    if (!returnData['summary'][param]) {
                        returnData['summary'][param] = 0;
                    }

                    returnData['summary'][param] += paramSum;
                    returnData[shop.id][param]  = Math.round(paramSum, 2)


                }



            }

            sumParams.forEach(newSumParam => {

                if (!returnData[shop.id].hasOwnProperty(newSumParam.name)) {
                    returnData[shop.id][newSumParam.name] = 0;
                }

                if (!returnData['summary'].hasOwnProperty(newSumParam.name)) {
                    returnData['summary'][newSumParam.name] = 0;
                }


                newSumParam.values.forEach(params2sum => {
                    if (returnData[shop.id].hasOwnProperty(params2sum)) {
                        returnData[shop.id][newSumParam.name] += returnData[shop.id][params2sum];
                        returnData['summary'][newSumParam.name] += returnData[shop.id][params2sum];
                    }
                })
            });
        }

        console.log(returnData);
        return returnData;
    }

    getShopsForStats(chartName) {
        let shopsToReturn = [];
        for (const key in this[chartName].selectedShops) {
            if (Object.hasOwnProperty.call(this[chartName].selectedShops, key)) {
                const element = this[chartName].selectedShops[key];
                if (element) {
                    shopsToReturn.push(this.shops.find(shop => shop.id == key));
                }
            }
        }
        return shopsToReturn
    }

    showNiceTime(seconds) {
        let duration = moment.duration(seconds, 'seconds');

        let daysString = duration.asDays() ? duration.days() + 'd ' : '';
        let timeString =  [
            ('0' + duration.hours()).slice(-2) + 'h ',
            ('0' + duration.minutes()).slice(-2) + 'm ',
            ('0' + duration.seconds()).slice(-2) + 's',
        ].join('')



        return   daysString + timeString;
    }

    showNiceTimeAxis(seconds) {
        let duration = moment.duration(seconds, 'seconds');

        let daysString = duration.asDays() ? duration.days() + 'd ' : '';
        let timeString =  [
            ('0' + duration.hours()).slice(-2) + 'h',
        ].join('')



        return   daysString + timeString;
    }
}

let DashboardComponent = {
    bindings: {},
    template: dashboardHtml,
    controller: DashboardController
};

export default DashboardComponent;
